const serializeResponsiveRuleQuery = (minWidth, maxWidth) => {
    const queries = [
        `(min-width: ${minWidth}px)`,
        maxWidth !== undefined ? `(max-width: ${maxWidth}px)` : undefined,
    ];
    return queries.filter(Boolean).join(' and ');
};
export const getResponsiveRules = (classes) => Object.entries(classes).reduce((acc, [key, breakpoint], index) => {
    const className = key;
    const previousRule = index > 0 ? acc[index - 1] : undefined;
    const containerNames = previousRule
        ? [
            ...previousRule.containerNames.slice(0, -1),
            `${className}AndUp`,
            className,
        ]
        : [`${className}AndUp`, className];
    const minWidth = previousRule?.maxWidth ?? 0;
    const maxWidth = breakpoint ? breakpoint - 1 : undefined;
    const query = serializeResponsiveRuleQuery(minWidth, maxWidth);
    return [...acc, { containerNames, minWidth, maxWidth, query }];
}, []);
